import axios from 'axios'
import * as CryptoJS from "crypto-js";
import qs from 'qs'
import storage from '../utils/localStore';
// export const baseURL = 'http://192.168.1.22:8080';
// export const baseURL = 'https://api.ynsjj88.com';
//export const baseURL = 'https://dispatcher.test.ynsjj88.com/api';
export const baseURL = 'https://dispatcher.pro.ynsjj88.com/api';


let navigateToLogin = null;
export const setNavigateToLogin = (navigate) => {
    navigateToLogin = navigate;
};

const instance = axios.create({
    baseURL,
    headers: {
        'content-type': 'application/json'
    }
});
// 添加请求拦截器
instance.interceptors.request.use(config => {
    let wordArray=CryptoJS.enc.Utf8.parse("dispatcher:dispatcher");
    // 从本地存储获取 token
    config.headers['Accept']="application/json";
    if(config.url.includes('oauth2/token')){
        config.headers['Content-Type']="application/x-www-form-urlencoded";
        config.headers['Authorization']="Basic "+CryptoJS.enc.Base64.stringify(wordArray);
    }else{
        config.headers['Content-Type']="application/json";
        let usr = storage.getItem('usr');
        if(usr){
            config.headers['Authorization']="Bearer "+usr.token;
        }
    }
    return config;
}, error => {
    return Promise.reject(error);
});
instance.interceptors.response.use(response => {
    return response;
}, error => {
    if(error.response.data.msg){
        console.error('Response error:', error.response.data.msg)
        //window.location.href = '/login';
    }
    return Promise.reject(error);
});

export function post(url, params) {
    const fullUrl = baseURL + url;
    if (url.includes('oauth2/token')) {
        let data = qs.stringify(params);
        let wordArray=CryptoJS.enc.Utf8.parse("dispatcher:dispatcher");
        return axios({
            url: fullUrl,
            method: 'post',
            data,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': "Basic "+CryptoJS.enc.Base64.stringify(wordArray)
            }
        })
    }else{
        return instance.post(fullUrl, params.data);
    }
}



// WEBPACK FOOTER //
// ./src/service/httpBase.js